import React, {useState, useCallback}  from 'react';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';

function FilterTypeDropdown({effect, value}) {
    const options = [
        {label: "Lowpass", value: "lowpass"},
        {label: "Highpass", value: "highpass"},
        {label: "Bandpass", value: "bandpass"},
        {label: "Notch", value: "notch"},
        {label: "Peaking", value: "peaking"},
    ];

    const onChange = useCallback((v) => {
        effect.type = v;
    }, []);

    const getOption = (value) => {
        return options.find(x => x.value === value);
    };

    return (
        <div className="filter-dropdown-container">
          <div className="dropdown-label">Type: </div>
        <Dropdown
          className='osc-type-dropdown'
          controlClassName='osc-type-control-dropdown'
          arrowClassName='osc-type-arrow-dropdown'
          options={options}
          onChange={(o) => onChange(o.value)}
          value={getOption(value)}
          placeholder="Type" />
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        value: props.effect.type,
    };
};

export default connect(mapStateToProps, null)(FilterTypeDropdown);
